import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

/*function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}*/

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, cellvalue, popupvalue } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    //const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(true); // isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      if (nativeEvent.key === 'Escape') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);



  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: '100%',
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {cellvalue}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{textAlign: 'left', padding: '10px 10px', zIndex: 100, width: '500px' }}
        >
          <Paper
            elevation={1}
            style={{
                minHeight: wrapper.current.offsetHeight - 3,
                backgroundColor: 'lightyellow',
                maxWidth: '500px', // optional cap
                whiteSpace: 'nowrap', // prevent wrapping
             }}
          >
            {popupvalue}

          </Paper>
        </Popper>
      )}
    </Box>
  );
});

function renderCellExpand(params) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth - 10} />
  );
}

export const createExpandableCell = ({ parseAsJson = false } = {}) => {
  return (params) => (
    <GridCellExpand
      value={params.value || ''}
      width={params.colDef.computedWidth - 10}
      parseAsJson={parseAsJson}
    />
  );
};

export const displayEmails = (parseAsJson = false ) => (params) => {
  const cellvalue = (params.row.Email??"").toLowerCase()
  const html = (<a href={`mailto:${(params.row.Email??"").toLowerCase()}`} >{(params.row.Email??"").toLowerCase()}</a>)
  return (
    <GridCellExpand key={`rcexp_${Date.now()}`} popupvalue={html || ''} cellvalue={cellvalue || ''} width={params.colDef.computedWidth - 10} />
  );
}

export const displayDirectors = (parseAsJson = false ) => (params) => {
  let dirs = []
  try {
    const dr = JSON.parse(params.value)
    for(const item of dr) //dr.map((item,index) => {
      dirs.push(item.toLowerCase().replace(/\b\w/g, s => s.toUpperCase()))
    //} )
  }catch(err) {

  }
  // const jdir = JSON.stringify(dirs)
  const cellvalue = dirs.join(", ")

  const html = (<><h4 style={{textAlign: 'center', marginBottom: 0, paddingBottom: '5px', padding: 0, marginTop: '5px'}}>Active Director / Offices</h4>
                  <ul style={{paddingTop: '10px', marginTop: 0}}>
                  {dirs.map((item, index) => (<li key={`dirs_${index}_${Date.now()}`} style={{verticalAlign: 'top',height: '24px!important', lineHeight: '20px!important'}}>{item}</li>))}
                  </ul><br/>
                </>
                )

    return (
      <GridCellExpand key={`rcexp_${Date.now()}`} popupvalue={html || ''} cellvalue={cellvalue || ''} width={params.colDef.computedWidth - 10} />
    );
};

export const displayPhones = (parseAsJson = false ) => (params) => {
  let dirs = []

  if(params.row.Phone1)
    dirs.push({type:'Main Number', number: params.row.Phone1,  notes:'Captured by Call Center'})
  if(params.row.Phone2)
    dirs.push({type:'Alt Main Number', number: params.row.Phone2, notes:'Captured by Call Center'})
  if(params.row.Mobile)
    dirs.push({type:'Mobile Number', number: params.row.Mobile, notes:'Captured by Call Center'})

  if(params.row["Additional Phone Numbers"] > "") {
    try {
      const jd = JSON.parse(params.row["Additional Phone Numbers"])
      dirs = [...dirs,...jd]
    }catch(err) {

    }
  }

  //const jdir = JSON.stringify(dirs)
  const cellvalue = dirs.map(item => item.number).join(", ")
  const html = (<>

                  <h4 style={{textAlign: 'center', marginBottom: 0, paddingBottom: '5px', padding: 0, paddingTop: '10px'}}>Phone Numbers</h4>
                  <table style={{padding: '5px 10px'}}>
                    <tbody>
                      {dirs.map((item,index) => (
                        <tr key={`aphtr_${index}_${Date.now()}`} >
                          <td  key={`aphtc1_${index}_${Date.now()}`}  style={{fontSize: '10pt'}} >{item.type}</td>
                          <td  key={`aphtc2_${index}_${Date.now()}`} style={{fontSize: '10pt'}} ><a href={`tel: ${item.number}`}>{item.number}</a></td>
                          <td  key={`aphtc3_${index}_${Date.now()}`} style={{fontSize: '9pt' , color: '#004AAC'}} >{item.notes}</td>
                        </tr>))
                      }
                    </tbody>
                  </table>
                  <br/>
                </>
                )

    return (
      <GridCellExpand popupvalue={html || ''} cellvalue={cellvalue || ''} width={params.colDef.computedWidth - 10} />
    );
};




export default renderCellExpand